import { client } from "../App";

import { ApiTypes } from "./../constants/ActionTypes.js"
//const url = "https://scuffedwebsite.com/chat/api/messages/";


// Request recent messages from database using custom header
export const fetchMessages = async () =>
{
  try
  {
    client.send(JSON.stringify({
      headers: {
        TYPE: ApiTypes.GET
      }
    }))
  }
  catch (err)
  {
    console.trace(err);
  }
}


// Add message to database and broadcast to other clients using custom header defined in 
// messageData
export const addMessage = async (messageData) =>
{
  client.send(JSON.stringify(messageData));
}


// Delete messages in database using custom header
// This should probably be removed but it's useful for testing purposes
export const Nuke = async () =>
{
  client.send(JSON.stringify({
    headers: {
      TYPE: ApiTypes.DELETE
    }
  }));
}